<mat-dialog-content class="mat-typography" style="overflow: visible">
    <app-mensaje-importante class="in-dialog"></app-mensaje-importante>
    <div style="text-align: center;">
      <h2>Este es el monto máximo para tu categoría</h2>
      <b>{{data.categoria}}</b>: <b>{{data.monto | currency : '$' : 'symbol' : '1.0-0'}}</b>
      <h3>
          Podés continuar y superarlo sin problemas<br/>
          sólo cambiarán las condiciones financieras
      </h3>
      <p>(tasa, plazos y % máximo a financiar)</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
  <button mat-button mat-dialog-close class="boton-gris-ftyc">Entendido</button>
</mat-dialog-actions>
